var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnLangSelectClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "btn-langSelect-close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "language",
    transform: "translate(-730.000000, -17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btn-langSelect-close",
    transform: "translate(730.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(17.000000, 17.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,-1 L9,7 L17,7 L17,8 L9,8 L9,16 L8,16 L8,8 L0,8 L0,7 L8,7 L8,-1 L9,-1 Z",
    transform: "translate(8.500000, 7.500000) rotate(45.000000) translate(-8.500000, -7.500000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLangSelectClose);
export default __webpack_public_path__ + "static/media/btn-langSelect-close.01f499287785fc6a7b56edb32fff2493.svg";
export { ForwardRef as ReactComponent };